import { IconActionClose16, IconActionMore16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as React from 'react';
import * as styles from './styles.css';

interface IPromoMenuControlProps {
  active: boolean;
  onClick(): void;
  ref?: React.Ref<HTMLDivElement>;
}

export const PromoMenuControl: React.FC<IPromoMenuControlProps> = ({ active, onClick, ref }) => {
  return (
    <div
      ref={ref}
      className={clsx(styles['container'], active && styles['container--active'])}
      onClick={onClick}
      data-testid="PromoMenuControl"
    >
      <div className={styles['close']}>
        <IconActionClose16 color="icon-inverted-default" />
      </div>
      <div className={styles['more']}>
        <IconActionMore16 color="icon-inverted-default" />
      </div>
    </div>
  );
};
